<template>

  <div>
    <div class="Banner">
      <img src="../../assets/hhy_banner.png" alt="">
    </div>
    <div class="container">
      <div class="title">
        <h1>
          混合云和私有云服务
        </h1>
        <aside>
          Hybrid cloud and private cloud services
        </aside>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <h4>悦享互联为企业事业单位提供混合云与私有云的建设服务，底层可基于虚拟化KVM, Vmware,Hyper -V等不同厂家的虚拟化技术，IAAS层面基于OpneStack的调度能力，为用户提供管理Portal
          </h4>
          <p>
            完整的云基础设置服务包括
          </p>
          <p>
            云服务业务调研咨询：
          </p>
          <h5>
            完成云计算中心业务模式调研分析；标准服务模型梳理及定义；服务流程定义；度量和KPI设计；服务质量保障(SLA) 梳理；
          </h5>
          <p>
            云计算数据中心建设：
          </p>
          <h5>
            根据业务模式定义完成云计算数据中心的基础设施改造和新建工作。搭建GDC环境，在用业务系统迁移，容灾，应急等业务持续性保障方案实施。
          </h5>

          <p>
            云服务管理平台设计开发
          </p>

          <h5>
            从资产管理、资源池管理、服务管理、交付管理四个层面建设管理平台，根据企业云计算中心具体需求定制开发云管理门户。
          </h5>
          <p>
            云计算中心代维管理：
          </p>
          <h5>
            提供云计算中心代维管理服务，根据确定的SLA为应用部门提供基础架构支持服务，使IT运维人员能从简单的日常操作中解放出来，从操作员转变为SLA监管和策略制定的角色，同时有更多精力熟悉企业业务应用，从而提供更符合企业发展方向的IT服务。
          </h5>
          <p>
            云服务交付流程示意图如下：
          </p>


        </div>
        <div>
          <img src="../../assets/cloud_service_pic.jpg" alt="">
        </div>
      </div>
    </div>
    <Footer />
  </div>


</template>

<script>

  import Footer from '../../components/Footer'

  export default {
    components: {
      Footer
    },

    props: {

    }

  }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  img {
    width: 100%;
  }

  .Banner {
    margin-bottom: 4rem;

  }

  h1 {
    font-size: 4.6rem;
    color: #fe9901;
  }

  aside {
    font-size: 1.6rem;
    color: #999;
    text-transform: uppercase;
  }

  .title {
    padding-left: 30px;
    border-left: 1px solid #ccc;
    margin-bottom: 4rem;
  }

  h5 {
    color: #333;
    font-size: 1.8rem;
    text-indent: 0px;
    line-height: 25px;
    margin-bottom: 25px;
    font-weight: normal;

  }

  h4 {

    color: #333;
    font-size: 1.8rem;
    text-indent: 30px;
    line-height: 25px;
    margin-bottom: 25px;
    font-weight: normal;

  }

  p {
    color: #333;
    font-size: 1.8rem;
    line-height: 25px;
    margin-bottom: 0px;
    font-weight: bold;
    text-indent: 0px;

  }

  aside {
    color: #666;
    font-size: 1.8rem;
    line-height: 35px;
    margin-bottom: 0px;
    font-weight: normal;
    padding-left: 30px;
  }

  .row {

    border-left: 50px;
  }


</style>
